export default __webpack_public_path__ + "static/media/columnNotAssignedIcon.ee050671.png";